// Openning hour
document.addEventListener('DOMContentLoaded', function() {
    var stores = document.querySelectorAll('.mm-modale-shop-open-hour');
    var now = new Date();
    var dayOfWeek = now.getDay(); // Dimanche = 0, Lundi = 1, ..., Samedi = 6
    var hour = now.getHours(); // Heure actuelle

    stores.forEach(function(store) {
        var openTime = store.querySelector('.mm-modale-store-open');
        var closeTime = store.querySelector('.mm-modale-store-close');
		var dot = store.querySelector('.shop-modal-dot');
        if (dayOfWeek >= 1 && dayOfWeek <= 5 && hour >= 10 && hour < 18) {
            store.classList.add('shop-is-open');
            openTime.style.display = 'flex';
            closeTime.style.display = 'none';
			dot.style.background = 'var(--success)';
        } else {
            store.classList.add('shop-is-close');
            openTime.style.display = 'none';
            closeTime.style.display = 'flex';
			dot.style.background = 'var(--primary)';
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const shopHours = document.querySelectorAll('.mm-modale-shop-open-hour');

    shopHours.forEach(function (shopHour) {
        shopHour.addEventListener('click', function () {
            this.classList.toggle('active');
            const weekHours = this.nextElementSibling;

            if (weekHours.style.maxHeight) {
                weekHours.style.maxHeight = null;
            } else {
                weekHours.style.maxHeight = weekHours.scrollHeight + 'px';
            }
        });
    });
});